import { Injectable } from '@angular/core';
import { Observable, of, delay } from 'rxjs';
import ApiOptionsConfig from '../api-options.config';
import { ApiBaseService } from '../api-base.service';
const BASE_URL = '/item-types';

@Injectable({
  providedIn: 'root'
})
export class ItemTypesService extends ApiBaseService {

  list(options?: ApiOptionsConfig): Observable<any> {
    return this.GET(this.getUrl(BASE_URL), options?.params);
  }

  detail(itemTypesId: number, options?: ApiOptionsConfig): Observable<any> {
    return this.GET(this.getUrl(`${BASE_URL}/${itemTypesId}`), options?.params);
  }

  create(data: any): Observable<any> {
    return this.POST(this.getUrl(BASE_URL), data);
  }

  update(itemTypesId: number, data: any): Observable<any> {
    return this.PUT(this.getUrl(`${BASE_URL}/${itemTypesId}`), data);
  }

  delete(itemTypesId: number): Observable<any> {
    return this.DELETE(this.getUrl(`${BASE_URL}/${itemTypesId}`));
  }
}
